import React from 'react';
import AppContainer from 'components/Layout/AppContainer';
import { MedicalCategoryPropertyProvider } from 'contexts/MedicalCategoryPropertyContext';

import MedicalCategoryListView from './components/MedicalCategoryListView';

export default function MedicalServicesPage() {
  return (
    <AppContainer>
      <MedicalCategoryPropertyProvider>
        <MedicalCategoryListView />
      </MedicalCategoryPropertyProvider>
    </AppContainer>
  );
}
